var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.125,
    height: 22.263,
    viewBox: "0 0 18.125 22.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00263e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Doc_download",
    "data-name": "Doc download",
    transform: "translate(-2024.686 -1529.905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    className: "cls-1",
    d: "M57.3,0H48.362a2.373,2.373,0,0,0-2.37,2.369v8.762h-.231a.955.955,0,0,0-.955.955v5.791a.955.955,0,0,0,.955.955h.231v1.062a2.372,2.372,0,0,0,2.369,2.369h12.2a2.372,2.372,0,0,0,2.369-2.369V5.608ZM46.386,12.882a8.179,8.179,0,0,1,1.227-.083,2.586,2.586,0,0,1,1.645.429,1.778,1.778,0,0,1,.679,1.514,2.036,2.036,0,0,1-.667,1.626,2.883,2.883,0,0,1-1.853.518,7.853,7.853,0,0,1-1.031-.06V12.882Zm14.177,7.93h-12.2a.919.919,0,0,1-.918-.918V18.832H58.817a.955.955,0,0,0,.955-.955V12.086a.955.955,0,0,0-.955-.955H47.444V2.369a.919.919,0,0,1,.918-.917l8.4-.009v3.1A1.644,1.644,0,0,0,58.4,6.192l3.041-.009.034,13.711A.919.919,0,0,1,60.562,20.812ZM50.35,14.866a1.944,1.944,0,0,1,1.954-2.1,1.872,1.872,0,0,1,1.907,2.032,1.914,1.914,0,0,1-1.972,2.115A1.872,1.872,0,0,1,50.35,14.866Zm6.515,1.287a2.275,2.275,0,0,0,.757-.131l.137.709a2.579,2.579,0,0,1-1.03.173,1.91,1.91,0,0,1-2.1-2.008,2.047,2.047,0,0,1,2.193-2.133,2.376,2.376,0,0,1,.989.178l-.185.721a1.953,1.953,0,0,0-.763-.149,1.208,1.208,0,0,0-1.281,1.329A1.2,1.2,0,0,0,56.865,16.153Z",
    transform: "translate(1979.88 1529.905)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_418",
    "data-name": "Ellipse 418",
    className: "cls-1",
    cx: 0.75,
    cy: 1.25,
    rx: 0.75,
    ry: 1.25,
    transform: "translate(2031.437 1543.537)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocDownload);
export default __webpack_public_path__ + "static/media/docDownload.af933ce3a6821c007f1cd1ed650884a2.svg";
export { ForwardRef as ReactComponent };